import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import {computed} from 'vue'
import attendance from '@/views/ViewsComponents/personalAttendance/attendance.vue'
// import attendceDeatils from '@/views/ViewsComponents/attendance/AttendanceDetails.vue'
import AttendceDeatils from '@/views/ViewsComponents/personalAttendance/attendanceDetails.vue'
import holidayCount from '@/views/ViewsComponents/personalAttendance/holidayCount.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const isMobile = computed(() => window.innerWidth <= 768)


return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_tabs, { type: "border-card" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, { label: "我的考勤" }, {
          default: _withCtx(() => [
            _createVNode(attendance)
          ]),
          _: 1
        }),
        (!_unref(isMobile))
          ? (_openBlock(), _createBlock(_component_el_tab_pane, {
              key: 0,
              label: "考勤详情",
              lazy: ""
            }, {
              default: _withCtx(() => [
                _createVNode(AttendceDeatils)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!_unref(isMobile))
          ? (_openBlock(), _createBlock(_component_el_tab_pane, {
              key: 1,
              label: "假期余额",
              lazy: ""
            }, {
              default: _withCtx(() => [
                _createVNode(holidayCount)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})